import initializers from './initializers';

export default {
  initializers,
};
